<template>
  <div class="mvh100 padding-10 flex flex-col">
    <help-item :list="list" class="flex-1" @change="changeList">
      <div class="flex-1 bg-common color-white padding-10 flex flex-col">
        <!--  v-if="dataList && dataList.length" -->
        <div class="flex flex-col">
          <!-- 列表 -->
          <div class="goods-item" :class="{'m-t-10':index>0}" @click="goDetail(item.supportInfoId)" v-for="(item,index) in dataList" :key="item.supportInfoId">
            <van-image :src="item.picUrl" fit="fill" width="100%" height="100%" lazy-load />
          </div>
          <!-- <div class="goods-item m-t-10" @click="goDetail(111)" >
            <van-image :src="item.picUrl" fit="fill" width="100%" height="100%" lazy-load />
          </div> -->
        </div>
        <div class="flex flex-row-center flex-col-center top-139" v-if="false">
          <no-data show-type="help" imgHeight="109px" imgWidth="131px" :imgSize="131" desc="别看了什么活动都没有!">
            <div class="color-desc" slot="description" style="margin-top:-20px">
              别看了什么活动都没有！
            </div>
          </no-data>
        </div>
      </div>
    </help-item>
  </div>
</template>
<script>
import helpItem from './help-item.vue'
import helpApi from '@/service/support'
import noData from '@/components/noData'
export default {
  components: { helpItem ,noData},
  data(){
    return {
      list:[{
        name:'助力商品'
      },{
        name:'助力优惠券'
      }],
      current:0,
      pages:[{
        page:1,
        pageSize:10,
        total:0
      },{
        page:1,
        pageSize:10,
        total:0
      }],
      dataList:[]
    }
  },
  created(){
    console.log(this.$route.query)
    this.getList()
  },
  methods:{
    goDetail:function(id){
      const param = {
        id:id,
        type:this.current+1
      }
      this.$navigateTo("help-detail",param)
    },
    /**
     * @description 获取助力列表
     */
    getList:function(isRefresh,isMore){
      const typeList = ['TYPE_ALL','TYPE_GOODS','TYPE_COUPON']
      const param = {
        page:this.pages[this.current].page,
        pageSize:this.pages[this.current].pageSize,
        type:typeList[this.current + 1] // 类型 ：0全部类型-TYPE_ALL、1商品-TYPE_GOODS、 2优惠券-TYPE_COUPON"
      }
      helpApi.list(param).then(res=>{
        console.log(res)
        if(res.success){
          this.dataList = res.result.list
        }else{
          this.$toast(res.message)
        }
      })
    },
    /**
     * @description tab切换事件
     */
    changeList:function(e){
      console.log(e)
      this.current = e
      this.pages[this.current].page = 1
      this.getList()
    }
  }
}
</script>
<style lang="less">
.padding-10{
  padding: 10px 10px 0 10px;
}
.bg-common{
  background: #FFE4A4;
}
</style>